'use client'

import './LangsToggler.scss'

import classNames from 'classnames'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import useSWR from 'swr'

import { eventModel } from '@/src/entities/event/model'

export type IHeader = {
  locale: string
}

const LangsToggler = ({ locale }: IHeader) => {
  const param = useParams<{ slug: string }>()

  if (!param.slug) return

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data } = useSWR(['event-key', param.slug, locale], ([, slug, locale]) =>
    eventModel.getEvent(slug, locale),
  )

  // if (!data?.is_translatable) return

  return (
    <>
      {data?.langs && (
        <ul className="header__languages">
          {Object.entries(data?.langs)
            // eslint-disable-next-line
            .filter(([_, value]) => value)
            .map(([key]) => (key === 'is_spanish' ? 'es' : key === 'is_portugal' ? 'pt' : 'en'))
            .map((lang) => (
              <li
                key={lang}
                className={classNames('header__languages-item', {
                  'header__languages-item--active': locale === lang,
                })}
              >
                <Link className="header__languages-link" href={`/${lang}/${param.slug}`}>
                  {lang}
                </Link>
              </li>
            ))}
        </ul>
      )}
    </>
  )
}

export default LangsToggler
